import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import RadioBlock from '../../../../../../components/Form/RadioBlock'
import Button from '../../../../../../components/Button'

import { CUSTOMIZED_MEDIA_OPTION, NO_CUSTOMIZED_MEDIA, UPLOAD_CUSTOMIZED_MEDIA } from '../../../fields'

import { CHIP_COLORS } from '../../../../../../constants/other'

import useStyles from '../../../../../../styles/common/stepForms'

const CustomizedMediaQuestionStep = ({ formik, handleStepChange, isActive }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { values, setFieldValue } = formik

  const customizedMediaOption = values[CUSTOMIZED_MEDIA_OPTION]

  const handleContinue = () => {
    handleStepChange()
  }

  // Preselect customizedMediaOption
  useEffect(() => {
    isActive && !customizedMediaOption && setFieldValue(CUSTOMIZED_MEDIA_OPTION, UPLOAD_CUSTOMIZED_MEDIA)
  }, [customizedMediaOption, isActive, setFieldValue])

  return (
    <>
      <div className={classes.stepTitle}>
        {t('Would you like to upload a customised image or video for story/reels positions?')}
      </div>
      <div className={classes.stepBody}>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="customized_media_recommended"
          name={CUSTOMIZED_MEDIA_OPTION}
          value={UPLOAD_CUSTOMIZED_MEDIA}
          selectedValue={values[CUSTOMIZED_MEDIA_OPTION]}
          label={t('Yes, I want to upload a vertical image or video')}
          badgeText={'Recommended'}
          badgeColor={CHIP_COLORS.success}
        />

        <RadioBlock
          setFieldValue={setFieldValue}
          id="no_customized_media"
          name={CUSTOMIZED_MEDIA_OPTION}
          value={NO_CUSTOMIZED_MEDIA}
          selectedValue={values[CUSTOMIZED_MEDIA_OPTION]}
          label={t('No')}
        />
      </div>
      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default CustomizedMediaQuestionStep
